import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraRouterProps } from "../InfraRouterProps";
import { InfraEntities } from "../InfraEntities";

interface IncidentViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class IncidentViewPage extends Component<IncidentViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.incident(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}